import { render, staticRenderFns } from "./CrudV1Properties.vue?vue&type=template&id=717ca062&"
import script from "./CrudV1Properties.vue?vue&type=script&lang=js&"
export * from "./CrudV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports